export default {
    searchHistory: (state) => state.searchHistory,
    oldQuantity: (state) => state.oldQuantity,
    quickView: (state) => state.quickView,
    filters: (state) => state.filters,
    checkOffers: (state) => state.checkOffers,
    valueFilters: (state) => state.valueFilters,
    singleProductsView: (state) => state.singleProductsView
}
